import {keepOnly} from "@Common/utils/objects";

import {toCssPos} from "../../../common/to-css-pos";

export const toCssRect = (rect) => ({
    ...toCssPos(rect),
    ...keepOnly(rect, ["width", "height"]),
});
